// Lembrete do fim do teste grátis — o canal LOCAL.
//
// UM CANAL POR LEMBRETE (decidido pelo servidor no CONFIRMAR_APP):
//   PUSH   há token FCM ativo e o aparelho permite push → só o servidor avisa
//          (sweepLembretesTeste) e nada é agendado aqui;
//   LOCAL  sem push disponível → este módulo agenda a notificação no próprio
//          horário, e o servidor não manda push.
// Assim não existe cenário de duas notificações para o mesmo lembrete.

import { Capacitor } from '@capacitor/core';
import { LocalNotifications } from '@capacitor/local-notifications';
import { lembreteTeste } from './anunciosApi';

export const ID_LEMBRETE_TESTE = 3001;

function textos(fimMs, enviarEmMs) {
  const dias = Math.max(1, Math.round((fimMs - enviarEmMs) / 86400000));
  const data = new Intl.DateTimeFormat('pt-BR', {
    timeZone: 'America/Sao_Paulo', day: 'numeric', month: 'short',
  }).format(new Date(fimMs));
  return {
    title: dias <= 1 ? 'Seu teste grátis acaba amanhã' : `Seu teste grátis acaba em ${dias} dias`,
    body: `O teste do LesVita Turbo termina em ${data}. `
      + 'Se não quiser continuar, é só cancelar na loja antes disso, sem custo.',
  };
}

/** Agenda o lembrete local (canal LOCAL). Silencioso em qualquer falha. */
export async function agendarReserva({ enviarEmMs, fimMs }) {
  if (!Capacitor.isNativePlatform() || !enviarEmMs || !fimMs) return;
  try {
    const at = new Date(Number(enviarEmMs));
    if (at.getTime() >= Number(fimMs) || at.getTime() <= Date.now()) return;
    const { title, body } = textos(Number(fimMs), Number(enviarEmMs));
    await LocalNotifications.schedule({
      notifications: [{
        id: ID_LEMBRETE_TESTE,
        title,
        body,
        schedule: { at, allowWhileIdle: true },
        extra: { type: 'lembrete_teste', fimMs: String(fimMs) },
        smallIcon: 'ic_stat_lesvita',
        channelId: 'lesvita_main',
      }],
    });
  } catch {
    /* a reserva é cortesia */
  }
}

export async function cancelarReserva() {
  if (!Capacitor.isNativePlatform()) return;
  try {
    await LocalNotifications.cancel({ notifications: [{ id: ID_LEMBRETE_TESTE }] });
  } catch {
    /* nada agendado */
  }
}

let _ligado = false;

/**
 * Na abertura: se o teste foi cancelado (ou expirou) desde que o lembrete
 * local foi agendado, cancela a notificação — quem cancelou não é avisado.
 */
export async function ligarDeduplicacao() {
  if (_ligado || !Capacitor.isNativePlatform()) return;
  _ligado = true;
  try {
    const pend = await LocalNotifications.getPending();
    const tem = (pend?.notifications || []).some((n) => Number(n.id) === ID_LEMBRETE_TESTE);
    if (!tem) return;
    const r = await lembreteTeste('STATUS');
    if (r && ['CANCELADO', 'EXPIRADO'].includes(r.status)) await cancelarReserva();
  } catch {
    /* tenta de novo na próxima abertura */
  }
}
